/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Voice_ChineseInputs */

const en_onboarding_voice_chinese = /** @type {(inputs: Onboarding_Voice_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chinese`)
};

const es_onboarding_voice_chinese = /** @type {(inputs: Onboarding_Voice_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chino`)
};

/**
* | output |
* | --- |
* | "Chinese" |
*
* @param {Onboarding_Voice_ChineseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_voice_chinese = /** @type {((inputs?: Onboarding_Voice_ChineseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Voice_ChineseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_voice_chinese(inputs)
	return en_onboarding_voice_chinese(inputs)
});